import React from 'react'
import Link from 'next/link'
import { type PageQuote } from '../types/generated/contentful'
import TestimonialCard from './TestimonialCard'

export const PageQuoteTestimonial = ({
  pageQuote,
  className,
}: {
  pageQuote: PageQuote
  className?: string
}) => (
  <Link
    href={pageQuote?.externalLink ?? pageQuote?.internalLink?.slug ?? ''}
    target={pageQuote.externalLink ? '_blank' : undefined}
  >
    <div className={`hover-translate-up h-full ${className || ''}`}>
      <TestimonialCard
        name={pageQuote.quote?.author?.name ?? ''}
        title={`${pageQuote.quote?.author?.role}, ${
          pageQuote.quote?.author?.company?.name ?? ''
        }`}
        quote={pageQuote.quote?.text ?? ''}
        profileImage={pageQuote.quote?.author?.avatar?.url ?? ''}
      />
    </div>
  </Link>
)
